import { getDefaultKeyBinding, KeyBindingUtil } from 'draft-js';

const bindings = e => {
  if (e.keyCode === 83 && KeyBindingUtil.hasCommandModifier(e)) return 'save'; // ctrl+s
  return getDefaultKeyBinding(e);
};

export default bindings;
